import axios from "axios";
import { SITELER } from "../detay/UrunDetay";

/**
 * Üye favori / fiyat alarmı uçları (her mağazanın kendi servisi: /api/alarm). Oturum jetonu AuthContext'in
 * localStorage'a yazdığı "token".
 */
export const GOOGLE_CLIENT_ID = process.env.GATSBY_GOOGLE_CLIENT_ID || "";

const jeton = () => {
  try {
    return localStorage.getItem("token");
  } catch (e) {
    return null;
  }
};

const basliklar = () => ({ Authorization: "Bearer " + jeton() });

const hataMetni = (e) => (e && e.response && e.response.data && e.response.data.hata) || "İşlem yapılamadı, tekrar dene";

export async function takipDurumu(site, urunId) {
  const r = await axios.get(SITELER[site].api + "api/alarm/urun", { params: { urunId }, headers: basliklar() });
  return r.data && r.data.urunId ? r.data : null;
}

/** degisiklik: { favori?, alarmTur? ("HEDEF" | "INDIRIM" | "" = kaldır), hedefFiyat? } */
export async function takipKaydet(site, urunId, degisiklik) {
  try {
    const r = await axios.post(SITELER[site].api + "api/alarm", { urunId, ...degisiklik }, { headers: basliklar() });
    return r.data && r.data.urunId ? r.data : null;
  } catch (e) {
    throw new Error(hataMetni(e));
  }
}

/** Tarayıcıya özel rastgele ziyaretçi kimliği (görüntüleme sayacı aynı kişiyi 24 saatte bir kez saysın). */
const ziyaretci = () => {
  try {
    let z = localStorage.getItem("iu_ziyaretci");
    if (!z) {
      z = Math.random().toString(36).slice(2) + Date.now().toString(36);
      localStorage.setItem("iu_ziyaretci", z);
    }
    return z;
  } catch (e) {
    return null; // sunucu IP + tarayıcıyla sayar
  }
};

/** Ürün sayfası açıldı: görüntüleme sayılır, { goruntulenme (son 24 saat), favori } döner. */
export async function ilgiSay(site, urunId) {
  const r = await axios.post(SITELER[site].api + "api/ilgi/goruntule", { urunId, ziyaretci: ziyaretci() });
  return r.data || null;
}

/** Üç mağazadaki takip listesi; bir mağaza cevap vermezse diğerleri gösterilir. */
export async function tumTakipler() {
  const l = await Promise.all(Object.keys(SITELER).map((site) =>
    axios.get(SITELER[site].api + "api/alarm/benim", { headers: basliklar() })
      .then((r) => (r.data || []).map((x) => ({ ...x, site })))
      .catch(() => [])));
  return l.flat().sort((a, b) => new Date(b.alarm.guncelleme) - new Date(a.alarm.guncelleme));
}

/** Google Identity Services betiği (tek kez yüklenir). */
let gsi = null;
export const googleYukle = () => {
  if (!gsi) {
    gsi = new Promise((res, rej) => {
      if (window.google && window.google.accounts) return res(window.google);
      const s = document.createElement("script");
      s.src = "https://accounts.google.com/gsi/client";
      s.async = true;
      s.onload = () => res(window.google);
      s.onerror = () => { gsi = null; rej(new Error("Google yüklenemedi")); };
      document.head.appendChild(s);
    });
  }
  return gsi;
};
